const DayEnd = () => import('./index.vue')

export default [
  { path: '/dayEnd', redirect: '/dayEnd/list' },
  { path: '/dayEnd/list', name: 'day-end-list', component: DayEnd, meta: { title: 'Day End' } },
]
